import { FC } from 'react';

import { PRICE_UNITS_ENUM_VALUES } from '@scripts/enums';
import { getDeclinedPriceUnit } from '@scripts/helpers';

import { PriceUnitLabelProps } from './types';

export const PriceUnitLabel: FC<PriceUnitLabelProps> = ({ priceUnit, quantity }) => {
    const declinedUnit = getDeclinedPriceUnit(priceUnit, quantity);

    if (declinedUnit) {
        return declinedUnit;
    }

    return (
        <span
            dangerouslySetInnerHTML={{
                __html: PRICE_UNITS_ENUM_VALUES[priceUnit],
            }}
        />
    );
};
